const hrnLocalStorage = {
  forgotPasswordKey: "fpw-data",
  getForgotPasswordData: () => {
    const data = localStorage.getItem(hrnLocalStorage.forgotPasswordKey);
    return data ? JSON.parse(data) : null;
  },
  setForgotPasswordData: (data: any) => {
    const strData = JSON.stringify(data);
    localStorage.setItem(hrnLocalStorage.forgotPasswordKey, strData);
  },
  clearForgotPasswordData: () => {
    localStorage.removeItem(hrnLocalStorage.forgotPasswordKey);
  },
  changeForgotPasswordData: (subData: any) => {
    const data = hrnLocalStorage.getForgotPasswordData();
    const newData = {
      ...data,
      ...subData
    };
    hrnLocalStorage.setForgotPasswordData(newData);
  }
};

export default hrnLocalStorage;
